<template>
  <a-modal
    title="编辑基础服务账单"
    :visible="visible"
    :mask-closable="false"
    :width="750"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk('form')"
  >
    <a-form-model
      ref="form"
      :model="form"
      label-align="right"
      :label-col="{ span: 7 }"
      :wrapper-col="{ span: 16 }"
      :rules="validateRules"
    >
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="基地："
            prop="baseId"
          >
            <a-select
              v-model="form.baseId"
              placeholder="请选择基地"
              allow-clear
              show-search
              :filter-option="filterOption"
              @inputKeydown="inputKeydown($event, checkResource)"
            >
              <a-select-option
                v-for="item in baseOptions"
                :key="item.baseId"
              >
                {{ item.baseName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            label="配比:"
            prop="ratio"
          >
            <a-input-number
              v-model="form.ratio"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')"
              placeholder="请选择配比"
              style="width: 100%;"
              :min="0"
              @change="ratioChange($event)"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item
            label="计收时间"
            prop="date"
          >
            <a-month-picker
              v-model="form.date"
              :format="monthFormat"
              disabled
              style="width: 100%;"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="当月含税收入:">
            <a-input
              v-model="form.preTaxAmount"
              disabled
              style="width: 100%;"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="代金券编码:"
            prop="voucherCode"
          >
            <a-input
              :value="form.voucherCode"
              placeholder="请填写代金券编码"
              disabled
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            label="代金券名:"
            prop="voucherName"
          >
            <a-input
              v-model="form.voucherName"
              placeholder="请填写代金券名"
              disabled
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="消耗额:"
            prop="consumptionAmount"
          >
            <a-input
              v-model="form.consumptionAmount"
              placeholder="请填写消耗额"
              disabled
              @change="consumptionChange($event)"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            label="公司名:"
            prop="enterpriseName"
          >
            <a-input
              v-model="form.enterpriseName"
              placeholder="请填写公司名"
              disabled
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="税率:"
            prop="taxRate"
          >
            <a-input-number
              v-model="form.taxRate"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')"
              style="width: 100%;"
              placeholder="请填写税率"
              :min="0"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="面额:"
            prop="denomination"
          >
            <a-input
              v-model="form.denomination"
              placeholder="请填写面额"
              disabled
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            label="ssn:"
            prop="ssn"
          >
            <a-input
              v-model="form.ssn"
              placeholder="ssn"
              disabled
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="月开始时间:"
            prop="monthStart"
          >
            <a-date-picker
              v-model="form.monthStart"
              style="width: 100%;"
              disabled
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            label="月结束时间:"
            prop="monthEnd"
          >
            <a-input
              v-model="form.monthEnd"
              placeholder="请选择月结束时间"
              disabled
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateConsumeRecord } from '@/api/vocherIncome'
import moment from 'moment'
import { deepClone, filterOption, inputKeydown } from '@/utils/utils.js'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    baseOptions: {
      type: Array,
      default: null
    },
    initData: {
      type: Object,
      default: null
    },
    productTypetions: {
      type: Array,
      default: null
    }
  },

  data () {
    return {
      form: {
        baseId: '',
        consumptionAmount: 0,
        date: '',
        denominationt: '',
        enterpriseName: '',
        monthEnd: '',
        monthStart: '',
        preTaxAmount: 0,
        ratio: 0,
        ssn: '',
        voucherCode: '',
        voucherConsumptionId: '',
        voucherName: '',
        taxRate: 0
      },
      validateRules: {
        baseId: [{ required: true, message: '基地不能为空' }],
        ratio: [{ required: true, message: '配比不能为空' }],
        taxRate: [{ required: true, message: '税率不能为空' }]
      },
      baseTemp: [],
      monthFormat: 'YYYY-MM'
    }
  },
  watch: {
    initData: {
      deep: true,
      handler: function (data) {
        data.monthStart =
           data.monthStart
             ? moment(data.monthStart).format('YYYY-MM')
             : null

        data.monthEnd =
           data.monthEnd
             ? moment(data.monthEnd).format('YYYY-MM')
             : null

        this.form = this.deepClone(data)

        this.form.consumptionAmount =
        this.form.consumptionAmount ||
              0

        this.form.preTaxAmount =
              this.form.preTaxAmount ||
              0

        this.form.ratio =
              this.form.ratio ||
              0

        this.form.taxRate =
              this.form.taxRate ||
              0
        this.form.date = moment(this.form.date).format('YYYY/MM')
      }
    }
  },
  methods: {
    moment,
    deepClone,
    filterOption,
    inputKeydown,
    getNum (num1, num2) {
      let num = ''
      if (Number(num1) === 0) {
        num = 0
      } else {
        num = Number(num2 / (num1 / 100)).toFixed(2)
      }
      return num
    },
    ratioChange (e) {
      let num = 0
      if (Number(e) === 0) {
        num = 0
      } else {
        num = this.getNum(e, Number(this.form.consumptionAmount))
      }
      this.form.preTaxAmount = num
    },
    consumptionChange (e) {
      const num = this.getNum(Number(this.form.ratio), e)
      this.form.preTaxAmount = num
    },
    // taxRateChange (e) {
    //   const num = this.getNum(e, Number(this.form.ratio), Number(this.form.consumptionAmount))
    //   this.form.preTaxAmount = num
    // },
    handleCancel () {
      this.$refs.form.resetFields()
      this.$emit('cancel')
    },
    handleOk (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          updateConsumeRecord({
            ...this.form
          })
            .then(() => {
              this.$message.success('提交成功!')
              this.$emit('ok')
            })
        }
      })
    }
  }
}
</script>
